import React from 'react';

import { useEventContext } from '../contexts/EventContext';

export const OnlineUsersIcon: React.FC = () => {
  const { setSearching } = useEventContext();

  return (
    <svg
      onClick={() => setSearching(true)}
      xmlns='http://www.w3.org/2000/svg'
      width='62'
      height='40'
      fill='none'
      viewBox='0 0 62 40'
    >
      <path
        fill='var(--card-background)'
        d='M0 8a8 8 0 018-8h46a8 8 0 018 8v24a8 8 0 01-8 8H8a8 8 0 01-8-8V8z'
      ></path>
      <path
        fill='var(--primary-accent)'
        fillRule='evenodd'
        d='M11 24.5c0-2.776 2.224-4.5 5-4.5s5.07 1.724 5.07 4.5c0 2.372-3.244 2.5-5.07 2.5-1.853 0-5-.102-5-2.5z'
        clipRule='evenodd'
      ></path>
      <path
        fill='var(--primary-accent)'
        d='M19 16a3 3 0 11-6 0 3 3 0 016 0zM31.64 16.5h-.968l-2 1.328v.985l1.953-1.297h.047V24.5h.969v-8zm2.114 6.36h3.766v1.64h.921v-1.64h1.094V22h-1.094v-5.5H37.27l-3.515 5.563v.796zM37.52 22H34.8v-.063l2.657-4.203h.063V22zm3.479 2.5h5.047v-.86h-3.719v-.062l1.797-1.922c1.375-1.472 1.781-2.16 1.781-3.047 0-1.234-1-2.218-2.406-2.218-1.402 0-2.469.953-2.469 2.359h.922c0-.91.59-1.516 1.516-1.516.867 0 1.531.532 1.531 1.375 0 .739-.434 1.285-1.36 2.297L41 23.796v.704zm9.223.11c1.597 0 2.71-.934 2.718-2.235-.007-1.012-.683-1.871-1.546-2.031v-.047c.75-.195 1.242-.93 1.25-1.781-.008-1.22-1.032-2.125-2.422-2.125-1.407 0-2.43.906-2.422 2.125-.008.851.484 1.586 1.25 1.78v.048c-.88.16-1.555 1.02-1.547 2.031-.008 1.3 1.105 2.234 2.719 2.234zm0-.86c-1.098 0-1.774-.563-1.766-1.422-.008-.902.738-1.547 1.766-1.547 1.011 0 1.758.645 1.765 1.547-.008.86-.683 1.422-1.765 1.422zm0-3.797c-.875 0-1.492-.547-1.485-1.375-.008-.812.586-1.344 1.485-1.344.883 0 1.476.532 1.484 1.344-.008.828-.625 1.375-1.484 1.375z'
      ></path>
    </svg>
  );
};
